import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  z-index: 1;
  align-items: center;
  margin-top: 100px;
  padding: 0 20px;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 0px 0px 80px 0px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
  }
`;

const ContactOptions = styled.div`
  width: 95%;
  max-width: 1000px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
  margin-top: 28px;
  padding: 0 20px;
`;

const ContactCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(17, 25, 40, 0.83);
  border: 1px solid rgba(255, 255, 255, 0.125);
  padding: 36px 28px;
  border-radius: 16px;
  box-shadow: rgba(23, 92, 230, 0.1) 0px 4px 24px;
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: rgba(23, 92, 230, 0.2) 0px 8px 32px;
    border-color: rgba(23, 92, 230, 0.3);
    
    & .contact-icon {
      transform: scale(1.1);
      filter: brightness(1.2);
    }
  }
`;

const ContactIcon = styled.div`
  font-size: 52px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(23, 92, 230, 0.1);
  backdrop-filter: blur(10px);
  
  /* Différents arrière-plans pour chaque icône */
  &.email {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
  }
  
  &.phone {
    background: linear-gradient(135deg, rgba(102, 234, 169, 0.15) 0%, rgba(75, 162, 118, 0.15) 100%);
  }
  
  &.linkedin {
    background: linear-gradient(135deg, rgba(10, 102, 194, 0.15) 0%, rgba(0, 119, 181, 0.15) 100%);
  }
`;

const ContactTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  margin-bottom: 12px;
  text-align: center;
`;

const ContactDetail = styled.a`
  font-size: 18px;
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  text-align: center;
  word-break: break-word;
  transition: all 0.2s ease;
  font-weight: 500;
  margin-bottom: 16px;
  
  &:hover {
    color: ${({ theme }) => theme.primary};
    text-decoration: underline;
    transform: scale(1.02);
  }
`;

const ContactParagraph = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.text_secondary};
  text-align: center;
  line-height: 1.6;
  margin-top: 12px;
  padding: 0 8px;
  opacity: 0.9;
  font-weight: 400;
`;

const ContactNote = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.text_secondary + "90"};
  text-align: center;
  max-width: 800px;
  margin-top: 40px;
  padding: 0 20px;
  line-height: 1.6;
`;

const Contact = () => {
  const contactInfo = {
    email: "yathrebsamaali25@gmail.com",
    linkedin: "https://www.linkedin.com/in/yathreb-samaali-0986a9241/",
    phone: "+216 99 157 801",
  };
  
  const contactDescriptions = {
    email: "For detailed discussions and formal inquiries. I respond within 24 hours.",
    phone: "For urgent calls or WhatsApp messages. Quick consultations available.",
    linkedin: "Connect for professional networking and career opportunities."
  };

  return (
    <Container id="contact">
      <Wrapper>
        <Title>Get In Touch</Title>
        <Desc>
          Feel free to reach out to me for any questions or opportunities!
        </Desc>
        
        <ContactOptions>
          {/* Email Card - Version améliorée */}
          <ContactCard>
            <ContactIcon className="contact-icon email">
              ✉️
            </ContactIcon>
            <ContactTitle>Email</ContactTitle>
            <ContactDetail href={`mailto:${contactInfo.email}`}>
              {contactInfo.email}
            </ContactDetail>
            <ContactParagraph>
              {contactDescriptions.email}
            </ContactParagraph>
          </ContactCard>
          
          {/* Phone Card - Version améliorée */}
          <ContactCard>
            <ContactIcon className="contact-icon phone">
              📱
            </ContactIcon>
            <ContactTitle>Phone</ContactTitle>
            <ContactDetail href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}>
              {contactInfo.phone}
            </ContactDetail>
            <ContactParagraph>
              {contactDescriptions.phone}
            </ContactParagraph>
          </ContactCard>
          
          {/* LinkedIn Card - Version améliorée */}
          <ContactCard>
            <ContactIcon className="contact-icon linkedin">
              💼
            </ContactIcon>
            <ContactTitle>LinkedIn</ContactTitle>
            <ContactDetail 
              href={contactInfo.linkedin} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Connect on LinkedIn
            </ContactDetail>
            <ContactParagraph>
              {contactDescriptions.linkedin}
            </ContactParagraph>
          </ContactCard>
        </ContactOptions>
        
        <ContactNote>
          Interested in collaborating? Reach out via email or phone, 
          or connect with me on LinkedIn.
          I'm always open to discussing new projects, creative ideas, 
          or opportunities to be part of your visions.
        </ContactNote>
      </Wrapper>
    </Container>
  );
};

export default Contact;